/**
 * Arabic translations for dashboard tips (post-registration).
 * Lightweight tips shown on first login for broker/company users.
 */

const onboarding = {
  tips: {
    inviteTeam: {
      title: 'ادع فريقك',
      description: 'اضف اعضاء الفريق للتعاون في الاعلانات وادارة العقارات معا.',
    },
    addListing: {
      title: 'اضف اعلانك الاول',
      description: 'انشئ اول اعلان عقاري لجذب المستأجرين.',
    },
    skipAll: 'تخطي جميع النصائح',
    gotIt: 'فهمت',
  },
};

export default onboarding;
